/*
 * ct-gift-picker.js
 *
 * De keuzepopup van EG Auto Add to Cart (vendor 506) hangt zichzelf als
 * fullscreen overlay (#aca-modal) aan de <body>. Deze module verplaatst dat
 * element naar binnen in de cart drawer (#HeaderCart), zodat het een sheet
 * wordt die binnen het paneel omhoogschuift.
 *
 * Uitgangspunt: wij raken alleen de PLEK in de DOM en de styling aan. Alle
 * logica - welke producten, welke korting, wat er bij een klik gebeurt -
 * blijft van de app. Daardoor blijft dit werken zolang de app zijn ID's
 * (#aca-modal, #aca-modal-container, #aca-bottom-close) niet hernoemt.
 *
 * LIJSTWEERGAVE (enhance): de app rendert per cadeau een kaart met een
 * eigen "Selecteer"-knop die direct toevoegt. Wij maken daar een lijst van:
 * per rij een keuzerondje, één grote knop onderaan, en een teller in de
 * ondertitel. De app-knoppen blijven in de DOM (verborgen); de grote knop
 * klikt onder water de app-knop van de gekozen rij. De app doet dus nog
 * steeds al het werk. Faalt deze laag, dan staan de app-knoppen er nog en
 * werkt de popup zoals de app hem bedoelde.
 *
 * De regels van de app worden gelezen via window.ctEasyGift
 * (assets/ct-eg-rules.js, wordt vóór dit bestand geladen). Dat is de enige
 * plek die het JSON-formaat van de app kent; de cadeauladder gebruikt
 * dezelfde parser.
 *
 * Teksten komen uit data-attributen op [data-cart-live] in
 * snippets/header-cart-drawer.liquid (Liquid, dus vertaald):
 *   data-gift-add-text  -> tekst op de grote knop
 *   data-gift-free-text -> badge in plaats van "€0,00"
 *
 * Styling: assets/ct-gift-picker.css
 *
 * Bewust GEEN ES module: dit wordt met een gewone <script defer> geladen
 * vanuit snippets/preload-js.liquid (dat snippet staat al in de <head> van
 * elke pagina) en heeft niets uit de theme-modules nodig.
 */
(function () {
  'use strict';

  var MODAL_ID = 'aca-modal';
  var DRAWER_ID = 'HeaderCart';
  var CLASS_ARMED = 'ct-gift-sheet-armed';
  var CLASS_SHEET = 'ct-gift-sheet';
  var CLASS_LIST = 'ct-gift-list';
  var CLASS_HOST = 'ct-gift-sheet-open';
  var CLASS_OPEN = 'is-open';
  var CLASS_SELECTED = 'is-selected';
  var CLASS_UNAVAILABLE = 'is-unavailable';

  /*
   * Als de popup na dit aantal ms nog steeds niet geadopteerd is, geven we
   * hem terug aan de app. Liever een lelijke fullscreen popup dan een
   * onzichtbare: de klant moet zijn cadeau kunnen kiezen.
   */
  var FAILSAFE_MS = 1500;

  /* Als de app na een klik op de grote knop niets doet (geen sluiten, geen
     loader), geven we de knop na dit aantal ms weer vrij. */
  var CTA_RELEASE_MS = 6000;

  var root = document.documentElement;
  var current = null;

  /*
   * Ketting voor meerdere cadeaus. De app voegt per klik één cadeau toe en
   * sluit de popup; pas bij een volgende cart-wijziging vraagt hij om het
   * volgende. Wij onthouden de resterende keuzes (productnamen), geven de
   * cart na het sluiten een duwtje zodat de app de popup opnieuw toont, en
   * vullen die automatisch in.
   */
  var queue = [];
  var nudgeTimer = null;

  /* Cadeaus die na de app-toevoeging van cadeau 1 nog zelf toegevoegd
     moeten worden (zie de CTA-handler). */
  var pendingDirect = null;

  /* Trace in de console (prefix [ct-gift]) om het gedrag van de app na een
     klik te volgen. Staat uit in productie; voor debuggen tijdelijk op true
     zetten. */
  var TRACE = false;
  function trace() {
    if (!TRACE || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[ct-gift ' + Math.round(performance.now()) + 'ms]');
    console.debug.apply(console, args);
  }

  /* De drawer laten herbouwen nadat de app een cadeau heeft toegevoegd. De
     app doet zijn eigen /cart/add; onze cart-form.js weet daar niets van.
     cart:build is het bestaande theme-event daarvoor (één GET). */
  function rebuildDrawerLater() {
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }, 1500);
  }

  function drawer() {
    return document.getElementById(DRAWER_ID);
  }

  function modal() {
    return document.getElementById(MODAL_ID);
  }

  function disarm() {
    root.classList.remove(CLASS_ARMED);
  }

  function strings() {
    var el = document.querySelector('[data-cart-live]');
    var d = el ? el.dataset : {};
    return {
      add: d.giftAddText || '',
      free: d.giftFreeText || ''
    };
  }

  /* De drawer bestaat alleen als cart type 'dropdown' is; anders stuurt het
     theme naar de cart-pagina en heeft adopteren geen zin. */
  function drawerUsable() {
    if (!drawer()) return false;
    try {
      return !window.theme || !theme.settings || theme.settings.cartType === 'dropdown';
    } catch (e) {
      return true;
    }
  }

  function drawerOpen() {
    var d = drawer();
    return !!d && d.classList.contains('is-active');
  }

  function isHidden(el) {
    return window.getComputedStyle(el).display === 'none';
  }

  /* -------------------------------------------------------------------------
     Lijstweergave
     ------------------------------------------------------------------------- */

  /* "€0,00" in welke notatie dan ook: alleen dan vervangen we de prijs door
     de badge. Staat er een echt bedrag (regel met 50% korting), dan blijft
     dat staan. */
  function isZeroAmount(text) {
    var digits = (text || '').replace(/[^\d]/g, '');
    return digits.length > 0 && /^0+$/.test(digits);
  }

  /* De keuzeregel die bij deze popup hoort: de 'offerToCustomer'-regel
     waarvan de producttitels precies de titels in de popup zijn. Parser in
     ct-eg-rules.js. Geen match (of geen parser): null, dan valt de code
     terug op de ondertitel. */
  function ruleFor(names) {
    try {
      return window.ctEasyGift ? ctEasyGift.ruleForTitles(names) : null;
    } catch (e) {
      return null;
    }
  }

  function limitFromRules(names) {
    var rule = ruleFor(names);
    var q = rule && rule.action.popupOptions && parseInt(rule.action.popupOptions.rewardQuantity, 10);
    return q && q > 0 ? q : null;
  }

  /* Variant-id van een popup-rij, uit de regel: het product op titel, de
     variant via de dropdown-index als die er is, anders de eerste. */
  function variantIdFor(rule, row) {
    var name = row.querySelector('.aca-product-name');
    if (!name || !rule) return null;
    var title = name.textContent.trim();
    var product = null;
    rule.action.products.forEach(function (p) {
      if ((p.title || '').trim() === title) product = p;
    });
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    var idx = 0;
    var sel = row.querySelector('select.aca-product-variants');
    if (sel) {
      var v = parseInt(sel.value, 10);
      if (!isNaN(v) && v >= 0 && v < product.variants.length) idx = v;
    }
    var vid = product.variants[idx] && product.variants[idx].id;
    return vid ? String(vid) : null;
  }

  /* Cadeaus zelf toevoegen: één /cart/add.js met alle gekozen varianten, met
     dezelfde eigenschap als de app zelf zet (_Gifted: regelnaam), via de
     Section Rendering-route van het theme zodat de drawer in één keer
     bijgewerkt wordt. De app-korting (Shopify Function) beoordeelt de cart
     server-side; staan de regels daarna niet op €0, dan halen we ze meteen
     weer weg en is de uitkomst false (de aanroeper valt dan terug op de
     app-knop). Kost dus nooit geld. */
  function addGiftsDirect(rule, vids) {
    if (!vids || !vids.length) return Promise.resolve(false);

    /* Exact zoals de app het doet (afgelezen uit DevTools, 24-9):
       één product per request, form-encoded, met ?_easygift_internal=true.
       Een JSON-request met een items-array leverde een andere line-key-hash
       op en geen korting. */
    function addOne(vid) {
      var body = 'id=' + encodeURIComponent(vid) +
        '&quantity=1' +
        '&properties%5B_Gifted%5D=' + encodeURIComponent(rule.name);
      return fetch('/cart/add.js?_easygift_internal=true', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (!data || data.status === 422 || !data.key) {
          trace('direct: toevoegen mislukt', vid, data);
          return null;
        }
        trace('direct: toegevoegd', data.title, 'key', data.key);
        return data.key;
      });
    }

    trace('direct: toevoegen', vids);
    return vids.reduce(function (p, vid) {
      return p.then(function (keys) {
        return addOne(vid).then(function (key) { return keys.concat(key ? [key] : []); });
      });
    }, Promise.resolve([])).then(function (keys) {
      if (keys.length !== vids.length) return cleanup(keys);
      /* Controle op de verse cart: staan de regels op €0? */
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var lines = (cart.items || []).filter(function (it) { return keys.indexOf(it.key) !== -1; });
        var notFree = lines.filter(function (it) { return (it.final_line_price || 0) > 0; });
        trace('direct: controle', lines.map(function (it) { return it.title + ' ' + it.final_line_price; }));
        if (notFree.length || lines.length !== keys.length) return cleanup(keys);
        document.dispatchEvent(new CustomEvent('cart:build'));
        return true;
      });
    }).catch(function (e) {
      trace('direct: fout', e && e.message);
      return false;
    });

    /* Korting niet toegepast of toevoegen onvolledig: alles weer weghalen */
    function cleanup(keys) {
      trace('direct: niet gratis of onvolledig, verwijderen', keys);
      return keys.reduce(function (p, key) {
        return p.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).catch(function () {});
        });
      }, Promise.resolve()).then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        return false;
      });
    }
  }

  /* Volgende cadeau uit de wachtrij automatisch toevoegen in een popup die
     al is opgebouwd (de app toont soms hetzelfde element opnieuw in plaats
     van een nieuw). Geeft true terug als er iets is aangeklikt. */
  function autoPick(el) {
    if (!queue.length) return false;
    var wanted = queue[0];
    var rows = el.querySelectorAll('.aca-product');
    for (var i = 0; i < rows.length; i++) {
      var n = rows[i].querySelector('.aca-product-name');
      var b = rows[i].querySelector('.aca-product-button');
      if (n && b && !b.disabled && n.textContent.trim() === wanted) {
        queue.shift();
        trace('autoPick: klik app-knop voor', wanted, 'rest:', queue.slice());
        el.classList.add('ct-gift-auto');
        window.setTimeout(function () { b.click(); }, 150);
        rebuildDrawerLater();
        return true;
      }
    }
    trace('autoPick: niets gevonden voor', wanted, 'in', Array.prototype.map.call(rows, function (r) { var n = r.querySelector('.aca-product-name'); return n ? n.textContent.trim() : '?'; }));
    queue = [];
    el.classList.remove('ct-gift-auto');
    return false;
  }

  function enhance(el) {
    if (el.__ctEnhanced) {
      autoPick(el);
      return;
    }
    var container = el.querySelector('#aca-products-container');
    if (!container) return;
    var rows = Array.prototype.slice.call(container.querySelectorAll('.aca-product'));
    if (!rows.length) return;
    el.__ctEnhanced = true;

    var txt = strings();

    /* Limiet: uit de regels van de app (rewardQuantity, zie limitFromRules).
       Terugval: het eerste getal in de ondertitel. Daarna 1. */
    var sub = el.querySelector('#aca-modal-subheadline');
    var names = rows.map(function (r) {
      var n = r.querySelector('.aca-product-name');
      return n ? n.textContent.trim() : '';
    }).filter(Boolean);
    var rule = ruleFor(names);
    var max = limitFromRules(names);
    if (!max && sub) {
      var m = (sub.textContent || '').match(/\d+/);
      if (m) max = Math.max(1, parseInt(m[0], 10));
    }
    if (!max) max = 1;
    var multi = max > 1;
    trace('enhance: limiet', max, 'producten', names);

    var state = { selected: [], rows: rows, cta: null, counter: null, max: max };

    rows.forEach(function (row) {
      var appBtn = row.querySelector('.aca-product-button');
      var unavailable = !appBtn || appBtn.disabled || appBtn.classList.contains('aca-product-out-of-stock-button');
      var name = row.querySelector('.aca-product-name');
      if (unavailable) row.classList.add(CLASS_UNAVAILABLE);

      /* Gratis-badge in plaats van de nul-prijs */
      var price = row.querySelector('.aca-product-discounted-price');
      if (price && txt.free && isZeroAmount(price.textContent)) {
        price.textContent = '';
        var badge = document.createElement('span');
        badge.className = 'ct-gift-free';
        badge.textContent = txt.free;
        price.appendChild(badge);
      }

      /* De app rendert was- en nu-prijs als twee losse <p>'s. In een rij
         horen ze naast elkaar in één cel: de was-prijs (<s>) verhuist naar de
         nu-prijs-<p>, de lege <p> gaat weg. */
      var prices = row.querySelectorAll('.aca-product-price');
      if (prices.length === 2 && price && prices[0] !== price) {
        var was = prices[0];
        while (was.firstChild) price.insertBefore(was.firstChild, price.firstChild);
        was.parentNode.removeChild(was);
      }

      /* Keuzerondje: radio bij één cadeau, checkbox bij meerdere */
      var check = document.createElement('button');
      check.type = 'button';
      check.className = 'ct-gift-check';
      check.setAttribute('role', multi ? 'checkbox' : 'radio');
      check.setAttribute('aria-checked', 'false');
      if (name) check.setAttribute('aria-label', name.textContent.trim());
      if (unavailable) {
        check.disabled = true;
      } else {
        check.addEventListener('click', function (evt) {
          evt.stopPropagation();
          select(row);
        });
      }
      row.appendChild(check);
      row.__ctCheck = check;

      if (!unavailable) {
        row.addEventListener('click', function (evt) {
          /* Klik in een dropdown of op de (verborgen) app-knop niet als keuze zien */
          if (evt.target.closest('select, .aca-product-dropdown, .aca-product-button, .ct-gift-check')) return;
          select(row);
        });
      }
    });

    /* Teller in de ondertitel: "0/2" -> "1/2" -> "2/2" */
    if (sub) {
      var counter = document.createElement('span');
      counter.className = 'ct-gift-count';
      counter.setAttribute('aria-hidden', 'true');
      counter.textContent = '0/' + max;
      sub.appendChild(counter);
      state.counter = counter;
    }

    /* Eén grote knop onderaan, vóór "Nee, bedankt" */
    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'ct-gift-cta';
    cta.disabled = true;
    cta.innerHTML = '<span class="ct-gift-cta__label"></span>';
    cta.querySelector('.ct-gift-cta__label').textContent = txt.add || 'OK';
    var bottomClose = el.querySelector('#aca-bottom-close');
    if (bottomClose && bottomClose.parentNode) {
      bottomClose.parentNode.insertBefore(cta, bottomClose);
    } else {
      container.parentNode.appendChild(cta);
    }
    state.cta = cta;

    /* De grote knop klikt de app-knop(pen) van de gekozen rij(en). Bij
       meerdere cadeaus na elkaar met een korte pauze, zodat de app elke
       toevoeging apart kan afhandelen. */
    cta.addEventListener('click', function () {
      var chosen = state.selected.filter(function (r) {
        var b = r.querySelector('.aca-product-button');
        return b && !b.disabled;
      });
      if (!chosen.length) return;
      cta.disabled = true;
      cta.classList.add('is-loading');

      /* VOLGORDE (gevonden in QA, 24-9): de app houdt onze /cart/change vast
         zolang de popup open staat; de cart staat server-side dus nog ONDER
         de drempel. Zelf toevoegen kan daarom pas nadat de app-knop voor
         cadeau 1 is geklikt: dat geeft de change vrij en zet cadeau 1 op
         €0. De overige cadeaus voegen wij daarna zelf toe, in exact het
         app-formaat (addGiftsDirect), zodra de popup weg is (release). */
      var restVids = [];
      if (rule) {
        chosen.slice(1).forEach(function (r) {
          var vid = variantIdFor(rule, r);
          if (vid) restVids.push(vid);
        });
      }
      pendingDirect = restVids.length ? { rule: rule, vids: restVids } : null;
      queue = [];

      trace('cta: cadeau 1 via app-knop, daarna zelf:', restVids);
      chosen[0].querySelector('.aca-product-button').click();
      rebuildDrawerLater();

      window.setTimeout(function () {
        if (el.isConnected && !isHidden(el)) {
          cta.disabled = false;
          cta.classList.remove('is-loading');
        }
      }, CTA_RELEASE_MS);
    });

    function render() {
      state.rows.forEach(function (r) {
        var on = state.selected.indexOf(r) !== -1;
        r.classList.toggle(CLASS_SELECTED, on);
        if (r.__ctCheck) r.__ctCheck.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      cta.disabled = state.selected.length === 0;
      if (state.counter) state.counter.textContent = state.selected.length + '/' + state.max;
    }

    function select(row) {
      if (!multi) {
        state.selected = [row];
      } else if (state.selected.indexOf(row) !== -1) {
        state.selected.splice(state.selected.indexOf(row), 1);
      } else {
        state.selected.push(row);
        /* Boven de limiet: de oudste keuze valt af */
        while (state.selected.length > state.max) state.selected.shift();
      }
      render();
    }

    /* Ketting: staat er nog een keuze in de wachtrij (tweede cadeau van een
       eerdere meervoudige keuze), dan die rij automatisch kiezen en
       doorklikken. Niet gevonden (andere regel, ander cadeau-aanbod), dan de
       wachtrij loslaten en de klant gewoon laten kiezen. */
    if (queue.length) {
      var wanted = queue[0];
      var hit = null;
      for (var q = 0; q < rows.length; q++) {
        var rn = rows[q].querySelector('.aca-product-name');
        if (rn && rn.textContent.trim() === wanted && !rows[q].classList.contains(CLASS_UNAVAILABLE)) { hit = rows[q]; break; }
      }
      if (hit) {
        queue.shift();
        state.selected = [hit];
        render();
        el.classList.add(CLASS_LIST);
        el.classList.add('ct-gift-auto');
        window.setTimeout(function () { cta.click(); }, 150);
        return;
      }
      queue = [];
    }

    /* Bij één cadeau het eerste beschikbare alvast aanvinken: één klik
       minder. Bij meerdere niet: de klant moet zelf kiezen. */
    if (!multi) {
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].classList.contains(CLASS_UNAVAILABLE)) { select(rows[i]); break; }
      }
    }
    render();

    el.classList.add(CLASS_LIST);
  }

  /* Cart een duwtje geven zodat de app zijn regels opnieuw beoordeelt en de
     popup voor het volgende cadeau toont.

     Stap 1: EasyGift.RefreshCart() als de app dat aanbiedt.
     Stap 2 (na 1,2 s, als de popup er nog niet is): een echte
     /cart/change.js op de eerste regel met hetzelfde aantal. Verandert niets
     aan de cart, maar is een change-request die de app onderschept - een
     lege /cart/update bleek daarvoor niet genoeg.
     Stap 3 (weer 2 s later): opgeven en de wachtrij leegmaken, zodat er
     nooit iets blijft hangen. */
  function nudgeCart() {
    clearTimeout(nudgeTimer);
    var tries = 0;

    function popupBack() {
      var el = modal();
      return !!el && !isHidden(el) && el.classList.contains(CLASS_OPEN);
    }

    function step() {
      trace('nudge: poging', tries + 1, 'popup terug', popupBack(), 'wachtrij', queue.slice());
      if (!queue.length || popupBack()) return;
      tries++;
      if (tries === 1) {
        var done = false;
        try {
          if (window.EasyGift && typeof EasyGift.RefreshCart === 'function') {
            EasyGift.RefreshCart();
            done = true;
          }
        } catch (e) { /* door naar stap 2 */ }
        nudgeTimer = window.setTimeout(step, done ? 1200 : 50);
        return;
      }
      if (tries === 2) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var line = cart && cart.items && cart.items[0];
            if (!line) return;
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: line.quantity })
            });
          })
          .catch(function () {});
        nudgeTimer = window.setTimeout(step, 2000);
        return;
      }
      queue = [];
    }

    nudgeTimer = window.setTimeout(step, 350);
  }

  /* -------------------------------------------------------------------------
     Adopteren in de drawer
     ------------------------------------------------------------------------- */

  function adopt(el) {
    var d = drawer();
    if (!d || !el || el.__ctAdopted) return;
    trace('adopt: nieuwe popup');

    /*
     * <dialog>: gebruikt de app showModal(), dan staat het paneel in de
     * browser-top-layer en negeert het elke parent - verplaatsen heeft dan
     * visueel geen effect. Sluiten en met het open-attribuut heropenen zet
     * hem terug in de normale flow. Gebruikt de app showModal() niet, dan
     * is dit een no-op.
     */
    var dlg = el.querySelector('dialog');
    if (dlg) {
      try {
        if (dlg.open) dlg.close();
      } catch (e) {
        /* close() gooit als de dialog niet open was; niets aan de hand */
      }
      dlg.setAttribute('open', '');
    }

    el.__ctAdopted = true;
    el.classList.add(CLASS_SHEET);
    d.appendChild(el);
    d.classList.add(CLASS_HOST);
    current = el;

    try {
      enhance(el);
    } catch (e) {
      /* Lijstweergave mislukt: de app-kaarten met eigen knoppen blijven werken */
      el.classList.remove(CLASS_LIST);
    }

    if (!drawerOpen()) {
      document.dispatchEvent(new CustomEvent('cart:open'));
    }

    /* Twee frames wachten zodat de browser de begintoestand
       (translateY(100%)) echt rendert en de transitie pakt. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (el.isConnected) el.classList.add(CLASS_OPEN);
      });
    });

    watch(el);
    focusFirst(el);
  }

  function focusFirst(el) {
    var target = el.querySelector('.ct-gift-check[aria-checked="true"]') ||
      el.querySelector('.aca-product-button:not([disabled])') ||
      el.querySelector('#aca-close-icon-container');
    if (target) {
      try {
        target.focus({ preventScroll: true });
      } catch (e) {
        target.focus();
      }
    }
  }

  function release(el) {
    trace('release: popup dicht/weg, connected', el.isConnected, 'wachtrij', queue.slice());
    el.classList.remove(CLASS_OPEN);
    var d = drawer();
    if (d) d.classList.remove(CLASS_HOST);
    if (current === el) current = null;
    if (pendingDirect) {
      var job = pendingDirect;
      pendingDirect = null;
      /* De app rondt zijn eigen add nog af; even wachten tot de cart-waarde
         inclusief de vrijgegeven change op de server staat. */
      window.setTimeout(function () {
        addGiftsDirect(job.rule, job.vids).then(function (ok) {
          trace('direct: klaar', ok);
        });
      }, 1200);
      return;
    }
    if (queue.length) nudgeCart();
  }

  /*
   * De app kan de popup weghalen OF hem verbergen met een inline display.
   * Beide gevallen moeten de host-class opruimen, anders blijft de drawer
   * denken dat er een sheet openstaat.
   */
  function watch(el) {
    var obs = new MutationObserver(function () {
      if (!el.isConnected) {
        release(el);
        obs.disconnect();
        return;
      }
      if (isHidden(el)) {
        release(el);
      } else if (!el.classList.contains(CLASS_OPEN)) {
        el.classList.add(CLASS_OPEN);
        var d = drawer();
        if (d) d.classList.add(CLASS_HOST);
        current = el;
        /* Opnieuw getoond door de app: volgende cadeau uit de ketting */
        if (queue.length) autoPick(el); else el.classList.remove('ct-gift-auto');
      }
    });
    obs.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });

    var parentObs = new MutationObserver(function () {
      if (!el.isConnected) {
        release(el);
        parentObs.disconnect();
        obs.disconnect();
      }
    });
    if (el.parentNode) {
      parentObs.observe(el.parentNode, { childList: true });
    }
  }

  function closeSheet() {
    queue = [];
    pendingDirect = null;
    if (!current) return false;
    /* Via de eigen knop van de app sluiten, zodat hun state klopt. */
    var btn = current.querySelector('#aca-bottom-close') ||
      current.querySelector('#aca-close-icon-container');
    current.classList.remove(CLASS_OPEN);
    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  function scan() {
    var el = modal();
    if (!el || el.__ctAdopted) return;

    if (!drawerUsable()) {
      /* Cart-pagina of geen drawer: laat de app zijn eigen popup tonen. */
      disarm();
      return;
    }

    adopt(el);

    /* Mocht adopteren om wat voor reden dan ook niet gelukt zijn, geef de
       popup dan alsnog terug in plaats van hem onzichtbaar te laten. */
    window.setTimeout(function () {
      var m = modal();
      if (m && !m.__ctAdopted) disarm();
    }, FAILSAFE_MS);
  }

  function init() {
    root.classList.add(CLASS_ARMED);

    scan();

    /* Hele boom observeren: waar de app #aca-modal precies aanhangt is niet
       gegarandeerd. scan() is goedkoop (één getElementById). */
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true
    });

    /*
     * Klik op de achtergrond van de sheet sluit hem. De klik blijft binnen
     * .site-header__cart, dus de drawer zelf gaat er niet van dicht.
     */
    document.addEventListener('click', function (evt) {
      if (current && evt.target === current) {
        evt.preventDefault();
        closeSheet();
      }
    });

    /*
     * Escape sluit eerst de sheet, niet meteen de hele drawer. De drawer
     * luistert op keyup in de bubbelfase op window; onze capture-listener
     * op window is eerder aan de beurt en stopt de event daar.
     */
    window.addEventListener('keyup', function (evt) {
      if (evt.key !== 'Escape' && evt.keyCode !== 27) return;
      if (!current || isHidden(current)) return;
      evt.stopImmediatePropagation();
      closeSheet();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
